
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ProductsHero from './components/ProductsHero';
import ProductGrid from './components/ProductGrid';

export default function ProductsPage() {
  useEffect(() => {
    document.title = 'Premium Products - Vapes Glass Hookah CBD Accessories | High Standards Smoke Shop';
    window.scrollTo(0, 0);

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Premium Products - High Standards Smoke Shop',
      description:
        'Browse our curated selection of premium vapes, fine glass, hookah, shisha, CBD products and accessories at High Standards Smoke Shop in Eustis, Florida.',
      url: `${siteUrl}/products`,
      isPartOf: {
        '@type': 'WebSite',
        name: 'High Standards Smoke Shop',
        url: siteUrl,
      },
      about: {
        '@type': 'LocalBusiness',
        name: 'High Standards Smoke Shop',
        telephone: '+13529774832',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '1321 S Bay St',
          addressLocality: 'Eustis',
          addressRegion: 'FL',
          postalCode: '32726',
          addressCountry: 'US',
        },
        sameAs: [
          'https://www.instagram.com/highstandardsmoke?igsh=MXd0YTRobGI0MWUzZw%3D%3D',
          'https://www.tiktok.com/@highstandards.smokes',
        ],
      },
      offers: {
        '@type': 'AggregateOffer',
        description: 'In-store purchase only. Valid government ID required.',
        availability: 'https://schema.org/InStoreOnly',
        priceCurrency: 'USD',
        seller: {
          '@type': 'LocalBusiness',
          name: 'High Standards Smoke Shop',
        },
      },
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-products';
    script.textContent = JSON.stringify(schema);
    const existing = document.getElementById('schema-products');
    if (existing) existing.remove();
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById('schema-products');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="bg-deep-black min-h-screen">
      <Navbar />
      <main>
        <ProductsHero />
        <ProductGrid />
      </main>
      <Footer />
    </div>
  );
}
